import React, { useState } from 'react';
import { Pagination } from '@amzn/awsui-components-react';
import { usePaginatedRedVelvetQuery } from './paginatedRedVelvetQuery';
import { useUrlPage } from './attendance/urlPage';
import { usePaginationStrings } from './localization/paginationStrings';
import { RedVelvetApiMethod, RedVelvetApiMethodParameters } from '../api/redVelvetQueries';
import { publishKatalMetric } from '../components/katalAnalytics';

export interface UrlControlledPaginationProps<K extends RedVelvetApiMethod> {
  paginationPrefix: string;
  namespaces?: string[];
  redVelvetQueryKey: [K, RedVelvetApiMethodParameters<K>];
  tableName: string;
}
export function UrlControlledPagination<K extends RedVelvetApiMethod>({
  paginationPrefix,
  namespaces = ['translation'],
  redVelvetQueryKey,
  tableName,
}: UrlControlledPaginationProps<K>) {
  const paginationStrings = usePaginationStrings(paginationPrefix, namespaces);
  const [largestPage, setLargestPage] = useState(1);
  const { page, setPage } = useUrlPage(1);
  const { queryResult } = usePaginatedRedVelvetQuery(
    { redVelvetQueryKey: redVelvetQueryKey },
    largestPage
  );
  // Added this to support the parent component to have more than one UrlControlledPagination using the same redVelvetQueryKey
  if (page > largestPage) {
    setLargestPage(page);
  }
  const isOpenEnded = queryResult.isLoading || queryResult.data?.page !== undefined;
  return (
    <Pagination
      ariaLabels={paginationStrings}
      currentPageIndex={page}
      onChange={({ detail }) => {
        setPage(detail.currentPageIndex);
        if (detail.currentPageIndex > largestPage) {
          setLargestPage(detail.currentPageIndex);
        }
        publishKatalMetric(tableName + '_pageChange', detail.currentPageIndex.toString());
      }}
      openEnd={isOpenEnded}
      pagesCount={largestPage}
    />
  );
}
